"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchSortToggle = exports.watchSetUserAndSetFollowState = exports.watchOnSaveClickSaga = exports.rootPlaceSagas = void 0;
var effects_1 = require("redux-saga/effects");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var GoogleMapLocationSaga_1 = require("@/pages/common/sagas/GoogleMapLocationSaga");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var NeighbourhoodSaga_1 = require("@/pages/place/sagas/NeighbourhoodSaga");
var NeighbourhoodInfo_1 = require("@/pages/place/states/NeighbourhoodInfo");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var stateToSearchQuery_1 = require("@/transformers/stateToSearchQuery");
var searchQueryToSaveSearchSet_1 = require("@/transformers/searchQueryToSaveSearchSet");
var NeighbourhoodApiSaga_1 = require("@/pages/place/sagas/api/NeighbourhoodApiSaga");
var VideoSaga_1 = require("@/pages/detail/sagas/VideoSaga");
var locationsToPoints_1 = require("@/transformers/locationsToPoints");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var SaveSearchDialogAction_1 = require("@/pages/search/actions/sfilter/SaveSearchDialogAction");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var ResultItemSaga_1 = require("@/pages/search/sagas/ResultItemSaga");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var SaveSearchDialogSaga_1 = require("@/pages/search/sagas/SaveSearchDialogSaga");
var PlaceVideoSagaSelector_1 = require("@/pages/place/sagas/PlaceVideoSagaSelector");
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
var PlaceAvailableSaga_1 = require("@/pages/place/sagas/PlaceAvailableSaga");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var RootTrendsSaga_1 = require("@/pages/common/sagas/RootTrendsSaga");
var RootTransactionsSaga_1 = require("@/pages/common/sagas/RootTransactionsSaga");
var getCurrentSort = function (state, filterType) {
    return filterType === SfilterTypeGroup_1.SfilterType.BUY ? state.place.availableSaleSort :
        state.place.availableRentSort;
};
var getCurrentOrder = function (state, filterType) {
    return filterType === SfilterTypeGroup_1.SfilterType.BUY ? state.place.availableSaleOrder :
        state.place.availableRentOrder;
};
var getPlaceState = function (state) { return state.place; };
var getCurrentActiveNeighhourhoodGroup = function (state) {
    return state.place.neighbourhood.active;
};
var getFullGallery = function (state) { return state.place.galleryItems; };
var isStickyAtTop = function (parentOffset) {
    var stickyTop;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.getStickyTop, 'stickymenu')];
            case 1:
                stickyTop = _a.sent();
                if (stickyTop === null)
                    return [2 /*return*/];
                if (!(parentOffset > stickyTop)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSticky(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSticky(false))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
};
var showPlaceNearbyPoints = function (latLng, radius, type) {
    var nearbys, points, subitems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.loadNearybyType, type, latLng, radius)];
            case 1:
                nearbys = _a.sent();
                return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.transformPlacesToPoint, nearbys, type)];
            case 2:
                points = _a.sent();
                subitems = nearbys.map(function (it, i) {
                    return ({ name: it.name, point: points[i] });
                });
                if (!(type === NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSubitems(type, subitems))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.renderPoints, points, latLng, 'neighbourhood-map')];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var fetchUserPlace = function (latLng) {
    var langCode, response, allPoints, points, subitems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.call(NeighbourhoodApiSaga_1.neighbourhoodApi, langCode)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, effects_1.call(locationsToPoints_1.transformLocationsToPoints, response.data.places)];
            case 3:
                allPoints = _a.sent();
                points = allPoints.filter(function (it) { return it.lat !== latLng.lat && it.lng !== latLng.lng; });
                if (!(allPoints.length === points.length)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setAddPlaceButtonActive(true))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setAddPlaceButtonActive(false))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7:
                if (points.length === 0)
                    return [2 /*return*/];
                subitems = points.map(function (it) { return ({ name: it.name, point: it }); });
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSubitems(NeighbourhoodInfo_1.NeighbourhoodItemType.PIN, subitems))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.renderPoints, points, latLng, 'neighbourhood-map')];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.fitBounds, points, latLng, 'neighbourhood-map')];
            case 10:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var showUserSavedLocations = function (latLng) {
    var isGuest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.renderPoints, [], latLng, 'neighbourhood-map')];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onLoginClicked())];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, effects_1.call(fetchUserPlace, latLng)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchMapTypeChange = function () {
    var action, mapType, mapTypeStr;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_SET_MAP_TYPE)];
            case 1:
                action = _a.sent();
                mapType = action.payload;
                mapTypeStr = mapType === GoogleMap_1.GoogleMapType.ROADMAP ? 'roadmap' : 'satellite';
                return [4 /*yield*/, effects_1.delay(200)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(GoogleMapLocationSaga_1.initAllGoogleMap)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(GoogleMapLocationSaga_1.setMapType, 'place-map', mapTypeStr)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchStickyMenu = function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 1:
                action = _a.sent();
                return [4 /*yield*/, effects_1.call(isStickyAtTop, action.payload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchNearbyTypeChanged = function () {
    var action, type, placeState, latLng, radius;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_SET_NEARBY_TYPE)];
            case 1:
                action = _a.sent();
                type = action.payload;
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourFilterType(type))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getPlaceState)];
            case 3:
                placeState = _a.sent();
                latLng = {
                    lat: placeState.lat,
                    lng: placeState.lng,
                };
                radius = 1000;
                return [4 /*yield*/, effects_1.call(NeighbourhoodSaga_1.renderCenter, latLng, radius, 'neighbourhood-map')];
            case 4:
                _a.sent();
                if (!(type === NeighbourhoodInfo_1.NeighbourhoodItemType.PIN)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.call(showUserSavedLocations, latLng)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, effects_1.call(showPlaceNearbyPoints, latLng, radius, type)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8:
                if (!(type !== NeighbourhoodInfo_1.NeighbourhoodItemType.PIN &&
                    type !== NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL)) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourMobileFilter(false))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
};
var watchOnSaveClickSaga = function (getStateCallback, getNameCallback, transformSearchQuery) { return function () {
    var isGuest, state, name, searchQuery, saveSearchSet;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_FOLLOW_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState('ss'))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(true))];
            case 6:
                _a.sent();
                return [3 /*break*/, 14];
            case 7: return [4 /*yield*/, effects_1.call(getStateCallback)];
            case 8:
                state = _a.sent();
                return [4 /*yield*/, effects_1.call(getNameCallback)];
            case 9:
                name = _a.sent();
                return [4 /*yield*/, effects_1.call(stateToSearchQuery_1.stateToSearchQuery, state, 24)];
            case 10:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(transformSearchQuery, searchQuery)];
            case 11:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(searchQueryToSaveSearchSet_1.searchQueryToSaveSearchSet, searchQuery, name)];
            case 12:
                saveSearchSet = _a.sent();
                saveSearchSet.languageId = state.layout.language.current;
                saveSearchSet.currencyId = state.layout.currencies.currentCurrencyId;
                return [4 /*yield*/, effects_1.call(SaveSearchDialogSaga_1.saveSearchSetToRemote, saveSearchSet)];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [3 /*break*/, 0];
            case 15: return [2 /*return*/];
        }
    });
}; };
exports.watchOnSaveClickSaga = watchOnSaveClickSaga;
var watchNeighbourFilterMobileActive = function () {
    var placeState, isMobileActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_TOGGLE_NEIGHBOUR_MOBILE_ACTIVE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getPlaceState)];
            case 2:
                placeState = _a.sent();
                isMobileActive = placeState.neighbourhood.mobileActive;
                if (!isMobileActive) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourMobileFilter(false))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourMobileFilter(true))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchSortToggle = function (getCurrentSortFn, getCurrentOrderFn) { return function () {
    var payload, newSort, filterType, currentSort, currentOrder, FORCE_RELOAD;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_ON_TOGGLE_SORT)];
            case 1:
                payload = (_a.sent()).payload;
                newSort = payload.type;
                filterType = payload.filterType;
                return [4 /*yield*/, effects_1.select(getCurrentSortFn, filterType)];
            case 2:
                currentSort = _a.sent();
                if (!(currentSort === newSort)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.select(getCurrentOrderFn, filterType)];
            case 3:
                currentOrder = _a.sent();
                if (!(currentOrder === PlaceState_1.AvailableSortOrder.ASC)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setOrder(PlaceState_1.AvailableSortOrder.DESC, filterType))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setOrder(PlaceState_1.AvailableSortOrder.ASC, filterType))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSort(newSort, filterType))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_ON_SORT_UPDATE_COMPLETED)];
            case 9:
                _a.sent();
                FORCE_RELOAD = true;
                return [4 /*yield*/, effects_1.call(WindowApi_1.lazyLoadImages, FORCE_RELOAD)];
            case 10:
                _a.sent();
                return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
}; };
exports.watchSortToggle = watchSortToggle;
var getContainerWidth = function (id) {
    var elementId;
    return __generator(this, function (_a) {
        elementId = document.getElementById(id);
        if (!elementId)
            return [2 /*return*/, false];
        return [2 /*return*/, elementId.clientWidth];
    });
};
var watchFullSize = function () {
    var payload, containerWidthFull, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_FULL_SIZE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(getContainerWidth, 'app')];
            case 2:
                containerWidthFull = _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setFullGalleryWidth(containerWidthFull + "px"))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.showPop(PlaceState_1.GalleryPopState.FULL))];
            case 4:
                _a.sent();
                index = payload;
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setGalleryIndex(index))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchSetPop = function () {
    var payload, state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_SHOW_POP)];
            case 1:
                payload = (_a.sent()).payload;
                state = payload;
                if (!(state === PlaceState_1.GalleryPopState.NONE)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setNoscroll(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setNoscroll(true))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchSaveSearchSuccess = function () {
    var payload, id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SaveSearchDialogAction_1.default.SAVE_SEARCH_SUCCESS)];
            case 1:
                payload = (_a.sent()).payload;
                id = payload;
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSaveSearchId(id))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSetUserAndSetFollowState = function (checkFollowState) { return function () {
    var payload, user, saveSearchId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                payload = (_a.sent()).payload;
                user = payload;
                if (!!user.email) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSaveSearchId(-1))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [4 /*yield*/, effects_1.call(checkFollowState)];
            case 4:
                saveSearchId = _a.sent();
                if (!saveSearchId) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSaveSearchId(saveSearchId))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}; };
exports.watchSetUserAndSetFollowState = watchSetUserAndSetFollowState;
// const setFilterToAll = function* () {
//   yield put(SfilterTypeAction.changeType(SfilterType.ALL));
// };
var watchAddPlaceClick = function () {
    var place, lang, address, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_ON_ADD_PLACE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getPlaceState)];
            case 2:
                place = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                lang = _a.sent();
                if (!place.lat)
                    return [3 /*break*/, 0];
                address = place.address ? place.address : place.name;
                return [4 /*yield*/, effects_1.call(NeighbourhoodApiSaga_1.addPlaceToRemote, place.name, address, place.lat, place.lng, lang)];
            case 4:
                response = _a.sent();
                if (!(response && response.data && response.data.isSaved)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.call(fetchUserPlace, { lat: place.lat, lng: place.lng })];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_location_success', BigPopupState_1.BigPopupType.SUCCESS, 'locationSaved', 'locationSavedCaption'))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_location_failed', BigPopupState_1.BigPopupType.FAILED, 'failed', 'locationSaveFailedCaption'))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [3 /*break*/, 0];
            case 10: return [2 /*return*/];
        }
    });
};
var watchSimilarSlider = function () {
    var slide, next, prev;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!window)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(GlobalCallSaga_1.initLazyLoad)];
            case 2:
                _a.sent();
                slide = function (element, from, to, duration) {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, new Promise(function (resolve) {
                                var startTime = performance.now();
                                var step = function (currentTime) {
                                    var elapseMs = currentTime - startTime;
                                    var moved = ((to - from) * elapseMs) / duration;
                                    var newScrollLeft = moved + from;
                                    if (to > from) {
                                        element.scrollLeft = Math.min(newScrollLeft, to);
                                        if (newScrollLeft < to) {
                                            requestAnimationFrame(step);
                                        }
                                        else {
                                            resolve();
                                        }
                                    }
                                    else {
                                        element.scrollLeft = Math.max(newScrollLeft, to);
                                        if (newScrollLeft > to) {
                                            requestAnimationFrame(step);
                                        }
                                        else {
                                            resolve();
                                        }
                                    }
                                };
                                requestAnimationFrame(step);
                            })];
                    });
                };
                next = function () {
                    var group, itemOffsets, currentLeft, currentIndex, nextIndex, newOffset;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                group = document.getElementById('similar-group');
                                itemOffsets = Array.from(group.children).map(function (it) { return it.offsetLeft; });
                                currentLeft = group.scrollLeft;
                                currentIndex = itemOffsets.findIndex(function (it) { return it > currentLeft; }) - 1;
                                nextIndex = currentIndex + 1 > itemOffsets.length - 1
                                    ? currentIndex
                                    : currentIndex + 1;
                                newOffset = itemOffsets[nextIndex];
                                return [4 /*yield*/, effects_1.call(slide, group, currentLeft, newOffset, 200)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                prev = function () {
                    var group, itemOffsets, currentLeft, currentIndex, prevIndex, newOffset;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                group = document.getElementById('similar-group');
                                itemOffsets = Array.from(group.children).map(function (it) { return it.offsetLeft; });
                                currentLeft = group.scrollLeft;
                                currentIndex = itemOffsets.findIndex(function (it) { return it > currentLeft; }) - 1;
                                prevIndex = currentIndex - 1 < 0 ? 0 : currentIndex - 1;
                                newOffset = itemOffsets[prevIndex];
                                return [4 /*yield*/, effects_1.call(slide, group, currentLeft, newOffset, 200)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                return [4 /*yield*/, effects_1.takeEvery(PlaceAction_1.default.PLACE_SIMILAR_NEXT, next)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(PlaceAction_1.default.PLACE_SIMILAR_PREV, prev)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchToggleNeighourhoodGroupActive = function () {
    var payload, groupId, currentGroupId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_TOGGLE_NEIGHBOUTHOOD_GROUP_ACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                groupId = payload;
                return [4 /*yield*/, effects_1.select(getCurrentActiveNeighhourhoodGroup)];
            case 2:
                currentGroupId = _a.sent();
                if (!(currentGroupId === groupId)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourhoodGroupActive(-1))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourhoodGroupActive(groupId))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchGalleryItemClicked = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var payload, src, galleryItems, matchedIndex, matchedVideoIndex;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_GALLERY_ITEM_CLICKED)];
                            case 1:
                                payload = (_a.sent()).payload;
                                src = payload;
                                return [4 /*yield*/, effects_1.select(getFullGallery)];
                            case 2:
                                galleryItems = _a.sent();
                                matchedIndex = galleryItems.findIndex(function (it) { return it.src === src; });
                                if (!(matchedIndex === -1)) return [3 /*break*/, 6];
                                matchedVideoIndex = galleryItems.findIndex(function (it) { return it.thumb === src; });
                                if (matchedVideoIndex === -1)
                                    return [2 /*return*/, "continue"];
                                // Play video in Popup
                                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setVideoPopupActive(true))];
                            case 3:
                                // Play video in Popup
                                _a.sent();
                                return [4 /*yield*/, effects_1.delay(1000)];
                            case 4:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(VideoAction_1.default.onPlayToggle())];
                            case 5:
                                _a.sent();
                                return [3 /*break*/, 8];
                            case 6: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.fullsize(matchedIndex))];
                            case 7:
                                _a.sent();
                                _a.label = 8;
                            case 8: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchContactAgentClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_ON_ENQUIRE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var sortToggleSaga = watchSortToggle(getCurrentSort, getCurrentOrder);
var watchPageInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(WindowApi_1.updateSlider)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var rootPlaceSagas = {
    placeAvailableSagas: PlaceAvailableSaga_1.placeAvailableSagas,
    rootTrendsSagas: RootTrendsSaga_1.rootTrendsSagas,
    rootTransactionsSagas: RootTransactionsSaga_1.rootTransactionsSagas,
    sortToggleSaga: sortToggleSaga,
    neighbourhoodSagas: NeighbourhoodSaga_1.neighbourhoodSagas,
    googleMapLocationSaga: GoogleMapLocationSaga_1.googleMapLocationSaga,
    videoSagas: VideoSaga_1.videoSagas(PlaceVideoSagaSelector_1.selector),
    watchMapTypeChange: watchMapTypeChange,
    watchStickyMenu: watchStickyMenu,
    watchNearbyTypeChanged: watchNearbyTypeChanged,
    watchOnMouseUp: ResultItemSaga_1.watchOnMouseUp,
    watchOnMouseDown: ResultItemSaga_1.watchOnMouseDown,
    watchOnItemClicked: ResultItemSaga_1.watchOnItemClicked,
    watchNeighbourFilterMobileActive: watchNeighbourFilterMobileActive,
    watchFullSize: watchFullSize,
    watchSetPop: watchSetPop,
    watchSaveSearchSuccess: watchSaveSearchSuccess,
    watchAddPlaceClick: watchAddPlaceClick,
    watchSimilarSlider: watchSimilarSlider,
    watchToggleNeighourhoodGroupActive: watchToggleNeighourhoodGroupActive,
    watchGalleryItemClicked: watchGalleryItemClicked,
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchOnResultEnquireClicked: ResultItemSaga_1.watchOnResultEnquireClicked,
    watchContactAgentClicked: watchContactAgentClicked,
    watchPageInit: watchPageInit,
};
exports.rootPlaceSagas = rootPlaceSagas;
